var render = function render(){var _vm=this,_c=_vm._self._c;return _c('binds-drawer',_vm._g(_vm._b({ref:"drawer",staticClass:"binds-app-drawer",attrs:{"binds-active":_vm.bindsActive && _vm.initialized,"binds-right":_vm.bindsRight}},'binds-drawer',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }